// TrialActivatedScreen — Phase 1 Plan 05; telegram-ui migration Phase 12 Plan 12-02.
//
// Success state после регистрации: <Placeholder> (header «Триал активен» +
// дата окончания / остаток дней) + stretched <Button> «Перейти к рейсам» →
// /dispatcher/trips. Haptic success на mount. Дата читается из ?ends_at.

import dayjs from "dayjs";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useSearchParams } from "react-router-dom";

import { Button, List, Placeholder } from "@telegram-apps/telegram-ui";

import { haptic } from "../lib/haptics";

export function TrialActivatedScreen(): React.JSX.Element {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const endsAtRaw = searchParams.get("ends_at");

  let daysLeft = 30;
  if (endsAtRaw) {
    const endsAt = dayjs(endsAtRaw);
    if (endsAt.isValid()) {
      daysLeft = Math.max(0, endsAt.diff(dayjs(), "day"));
    }
  }

  // Success state — тактильный отклик один раз на mount (Pitfall 5 / UI-SPEC §Platform).
  useEffect(() => {
    haptic.success();
  }, []);

  return (
    <List>
      <Placeholder
        header={t("trial.title")}
        description={
          <span data-testid="trial-days-left">{t("trial.days_left", { days: daysLeft })}</span>
        }
        action={
          <Button
            size="l"
            stretched
            onClick={() => navigate("/dispatcher/trips")}
            data-testid="trial-go-to-trips"
          >
            {t("trial.go_to_trips")}
          </Button>
        }
      >
        {t("trial.activated")}
      </Placeholder>
    </List>
  );
}
